// extracted by mini-css-extract-plugin
export default {"holder":"NotificationBell_holder__0q4Wp","count":"NotificationBell_count__OiYyD"};